import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'components/Avatar';
import Icon from 'components/Icon';
import cx from 'classnames';
import {connect} from 'react-redux';
import {getUserById} from 'state/user/userSelectors';
import {load} from 'state/user/userActions';
import './UserListItem.css';

class UserListItem extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.load(this.props.userId);
  }

  handleClick(e) {
    e.persist();
    e.data = {
      userId: this.props.userId,
    };
    this.props.onClick && this.props.onClick(e);
  }

  render() {
    if (!this.props.user) return null;

    return (
      <div
        className={cx({
          UserListItem: true,
          'UserListItem--selected': this.props.selected,
        })}
        onClick={this.handleClick.bind(this)}
      >
        <div className="UserListItem__AvatarContainer">
          <Avatar userId={this.props.userId} size={Avatar.sizes.MEDIUM} />
        </div>
        <div className="UserListItem__DisplayName">
          {this.props.user.displayName}
        </div>
        {this.props.selected ? <Icon icon={Icon.OPTIONS.CHECK} /> : null}
      </div>
    );
  }
}

UserListItem.propTypes = {
  userId: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

export default connect(
  (state, props) => {
    return {
      user: getUserById(state, props.userId),
    };
  },
  {
    load,
  }
)(UserListItem);
